import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate, articleLabel } from "../../lib/api";
import { PublicNav, PublicFooter } from "../../components/public/PublicNav";
import { useSeo } from "../../hooks/useSeo";

export const PublicArticles = () => {
  useSeo({
    title: "Dossiers, interviews & coups de cœur | Rouge Première",
    description: "Retrouvez tous les articles de la rédaction Rouge Première : dossiers de fond, interviews, critiques et coups de cœur cinéma & séries.",
  });
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PublicNav />
      <section className="max-w-[1300px] mx-auto px-5 md:px-10 pt-12 md:pt-16">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">La rédaction</div>
        <h1 className="font-display text-4xl md:text-6xl mt-2">
          Dossiers, coups de cœur & <span className="editorial-underline italic">interviews</span>
        </h1>
      </section>

      <section className="max-w-[1300px] mx-auto px-5 md:px-10 mt-12 pb-12">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-[220px] rounded-md bg-neutral-100 animate-pulse" />
            ))}
          </div>
        ) : articles.length === 0 ? (
          <div className="text-center py-24">
            <div className="font-display text-3xl">Le premier article arrive bientôt.</div>
            <p className="text-neutral-500 mt-2 text-sm">Rendez-vous très prochainement.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/articles/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group block card-lift"
              >
                <div className="h-[220px] rounded-md overflow-hidden bg-neutral-50 mb-4 border border-[var(--line)] flex items-center justify-center">
                  {a.cover_image_url ? (
                    <img
                      src={a.cover_image_url}
                      alt={a.title}
                      className="w-auto max-w-full max-h-[220px] object-contain transition-transform duration-700 group-hover:scale-[1.03]"
                    />
                  ) : (
                    <div className="w-full h-full grid place-items-center font-display italic text-[var(--red)] text-2xl">
                      Rouge Première
                    </div>
                  )}
                </div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">
                  {articleLabel(a)}
                </div>
                <h3 className="font-display text-2xl mt-1.5 group-hover:underline decoration-[var(--red)] underline-offset-4">
                  {a.title}
                </h3>
                {a.subtitle && (
                  <p className="text-neutral-600 mt-2 leading-relaxed line-clamp-2">{a.subtitle}</p>
                )}
                <div className="text-[11px] text-neutral-400 mt-3 uppercase tracking-widest">
                  {fmtDate(a.published_at)} · {a.author_display || a.author_name || a.author_email}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      <PublicFooter />
    </div>
  );
};
